<ng-container *ngIf="aggregated$ | async as aggregated">
    <div class="products d-grid gap-lg">
        <app-pen-product-card
            *ngFor="let group of aggregated"
            [sale]="sale"
            [product]="group"
            [selected]="isGroupSelected(group)"
            [selectedProductId]="getSelectedProductIdInGroup(group)"
            (selectedProductIdChange)="onGroupSelectionChange(group, $event)"
            (remove)="resetGroupSelection(group)"
        >
        </app-pen-product-card>
    </div>
</ng-container>
